<template>
    <div>
      <!-- <h1 style="color: green;"><b>PRIHLÁSENIE</b></h1> -->
      <!-- <HelloWorld msg="PRIHLÁSENIE" /> -->
      
      <form class="login" @submit.prevent="login">
          
          <!--<label>User name</label>-->
          <!-- <input required v-model="username" type="text" placeholder="e-mail"/> -->
          
          <div style="height: 3em"/>
          <b-field >
              <b-input required v-model="username" placeholder="e-mail"></b-input>
          </b-field>

          <br>
          <!--<label>Password</label>-->
          <!-- <input required v-model="password" type="password" placeholder="heslo"/> -->
          <!-- <b-field label="password"> -->
          <b-field>
              <b-input required v-model="password" type="password" placeholder="heslo"></b-input>
          </b-field>
          <br>
          <!-- <button type="submit">Login</button> -->
          <div class="buttons my-center-horizontal" type="submit">

            <button class="button is-primary" type="submit">
              <strong>PRIHLÁSIT</strong>
            </button>
          </div>
      </form>

      <br><br>
      <div class="buttons my-center-horizontal">

          <!-- <button class="button is-primary">
            <strong>Login with Google</strong>
          </button>

          <button class="button is-primary">
            <strong>Login with Facebook</strong>
          </button> -->
      
      </div>
      <!--
      <form class="logout" @submit.prevent="logout">
        <button type="submit">Logout</button>
      </form>
      -->
    </div>
</template>


<script>

    import { AUTH_REQUEST, AUTH_LOGOUT } from '../../store/actions/auth'
    // import { HelloWorld } from '@/components/HelloWorld.vue'

    export default {

      name: 'login',
      // components: {
      //   HelloWorld,
      // },
      data () {
        if (process.env.NODE_ENV == 'production') {
        return {
            username: '',
            password: '',
          } 
        } else {
          return {
            username: 'me',
            password: 'pwd'
          }
        }
      },
      methods: {
        login: function () {

          
          // TODO remove later production / development
          if (process.env.NODE_ENV == 'production') {
            if (this.username != 'demo' && this.password != 'demo11') {
              this.$router.push('/')
              return
            }
          } else {
            console.log('development mode -> no pwd check')
            // console.log('development mode -> no pwd check > '+this.username+' / '+this.password)
          }

          const { username, password } = this;
          this.$store.dispatch(AUTH_REQUEST, { username, password }).then(() => {

            this.$router.push('/main/dashboard')
          })
        },
        logout: function () {
          this.$store.dispatch(AUTH_LOGOUT).then(() => {
            this.$router.push('/')
          })
        }
      }
    }

</script>




<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .my-center-horizontal {
    display: block;
  }

</style>
